package app

import kotlinx.datetime.Clock
import kotlinx.datetime.TimeZone
import kotlinx.datetime.todayIn

/** Date helpers shared by frontend and backend. */
object Dates {

    /** Current local date as an epoch day (days since 1970-01-01). */
    fun today(): Long =
        Clock.System.todayIn(TimeZone.currentSystemDefault()).toEpochDays().toLong()

    /** Human label for a movie's last watch, e.g. "assistido ha 12 dias", "nunca". */
    fun lastWatchedLabel(movie: Movie, today: Long): String {
        val day = movie.lastWatchedDay ?: return "nunca assistido"
        return when (val d = (today - day).coerceAtLeast(0)) {
            0L -> "assistido hoje"
            1L -> "assistido ontem"
            else -> "assistido ha $d dias"
        }
    }
}
